import { APP_NAME } from '@/lib/constants';
import { cn } from '@/lib/utils';

export const WORKLYNX_MARK_SRC = '/assets/icons/favicon.svg';
export const WORKLYNX_WORDMARK_SRC = '/assets/logo/worklynx-logo-512.png';
export const WORKLYNX_APP_ICON_SRC = '/assets/logo/worklynx-logo-192.png';

interface BrandImageProps {
  alt?: string;
  className?: string;
}

interface BrandLockupProps {
  className?: string;
  markClassName?: string;
  textClassName?: string;
  text?: string;
}

export function WorklynxMark({
  alt = APP_NAME,
  className,
}: BrandImageProps) {
  return (
    <img
      src={WORKLYNX_MARK_SRC}
      alt={alt}
      className={cn('select-none object-contain', className)}
      draggable={false}
    />
  );
}

export function WorklynxWordmark({
  alt = APP_NAME,
  className,
}: BrandImageProps) {
  return (
    <img
      src={WORKLYNX_WORDMARK_SRC}
      alt={alt}
      className={cn('select-none object-contain', className)}
      draggable={false}
    />
  );
}

export function WorklynxBrandLockup({
  className,
  markClassName,
  textClassName,
  text = APP_NAME,
}: BrandLockupProps) {
  return (
    <span className={cn('flex min-w-0 items-center gap-3', className)}>
      <WorklynxMark alt="" className={cn('h-10 w-10 shrink-0', markClassName)} />
      <span className={cn('truncate text-lg font-semibold', textClassName)}>
        {text}
      </span>
    </span>
  );
}
